import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLoaderComponent } from './shared/component/app-loader/app-loader.component';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material/material.module';
import { AppService, startupServiceFactory } from './app.service';
import { UrlJsonConfig } from './url-config';
import { HttpClientModule } from '@angular/common/http';
import { NgxMaskModule } from 'ngx-mask';
import { CoreModule } from './core.module';
import { TimeoutWarningComponent } from './shared/component/timeout-warning/timeout-warning.component';
import { AuthModule } from './auth/auth.module';

@NgModule({
  declarations: [
    AppComponent,
    AppLoaderComponent,
    TimeoutWarningComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AuthModule,
    LayoutModule,
    MaterialModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    CoreModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
    AppService,
    UrlJsonConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [AppService],
      multi: true
    },
  ]
})
export class AppModule { }
